// This method prevents an error from the form validation on Internet Explorer Windows 10 Versie 20H2
// This error will be solved by submitting the form with JavaScript (see ticket https://service.thevalley.nl/browse/UTRB-312)

const submitForm = function () {
	const $triggers = document.querySelectorAll('.js-submit-form');
	$triggers.forEach($trigger => {
		const $form = document.querySelector($trigger.dataset.submitFormRel);
		$trigger.addEventListener('click', e => {
			e.preventDefault();
			$form.submit();
		});
	});
}

module.exports = submitForm;